import React from "react";

const Logo = ({ color }) => {
  return <img  src="/images/Craftsman.png"></img>;
};

export default Logo;
